let inited = false;

initSlider();
window.addEventListener('resize', initSlider);

function initSlider() {
    let $slider = $('.format-list');
    if(window.innerWidth > 560){
        $slider.trigger('destroy.owl.carousel');
        inited = false;
        return;
    }

    if(inited)
        return;

    $slider.owlCarousel({
        items: 1.5,
        center: true,
        margin: 30,
    });
}
